import { motion } from "framer-motion";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { FadeUp } from "@/components/motion/Reveals";
import { useLang } from "@/i18n/LangContext";

const Terms = () => {
  const { t, lang, setLang } = useLang();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  return (
    <div data-testid="terms-page" className="min-h-screen py-24 md:py-32">
      <div className="max-w-3xl mx-auto px-6 md:px-10">
        <div className="flex items-center justify-between mb-14">
          <Link
            to="/"
            data-testid="terms-back"
            className="overline text-[#6B6554] hover:text-[#3A3524] transition-colors"
          >
            ← {t.terms.back}
          </Link>
          <div className="flex items-center gap-2 text-[11px] tracking-[0.2em]">
            <button
              onClick={() => setLang("pt")}
              className={lang === "pt" ? "text-[#3A3524]" : "text-[#3A3524]/40"}
            >
              PT
            </button>
            <span className="text-[#3A3524]/30">/</span>
            <button
              onClick={() => setLang("en")}
              className={lang === "en" ? "text-[#3A3524]" : "text-[#3A3524]/40"}
            >
              EN
            </button>
          </div>
        </div>

        <FadeUp>
          <div className="overline text-[#6B6554] mb-4">{t.terms.updated}</div>
        </FadeUp>

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.7, 0, 0.15, 1] }}
          className="font-serif text-5xl md:text-7xl leading-[1] text-[#3A3524] mb-16 tracking-tight"
        >
          {t.terms.title}
        </motion.h1>

        <div className="flex flex-col gap-10">
          {t.terms.sections.map((s, i) => (
            <FadeUp key={i} delay={i * 0.05}>
              <div className="border-t border-[#3A3524]/15 pt-6">
                <h3 className="font-serif italic text-2xl md:text-3xl text-[#3A3524] mb-4">
                  {s.h}
                </h3>
                <p className="text-[#3A3524]/80 leading-relaxed font-light">{s.p}</p>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Terms;
